import * as React from 'react';

var NoPower = function NoPower() {
  return /*#__PURE__*/React.createElement("img", {
    src: "//img10.360buyimg.com/imagetools/jfs/t1/208390/5/4987/46663/61653d2aE94996d49/d5984cad4212d275.png",
    width: "252",
    height: "147",
    alt: "no-power"
  });
};

export default NoPower;